export type User = {};

export type ApiKey = {
  id: string;
  description: string;
  serialNumber: string;
  key: string;
  expires: Date;
  revoked: boolean;
};

export type ApiKeySettings = {
  permissions: string[];
  maxExpirationInYears: number;
};

export type Device = {
  installationId: number;
  installationName: string;
  model: string;
  serialNumber: string;
  verifiedAccess: boolean;
  deviceSupported: DeviceSupported;
};

export type DeviceSupported =
  | 'Supported'
  | 'UnsupportedGenesisVersion'
  | 'UnsupportedThermiaConnectVersion'
  | 'UnsupportedConnectionType'
  | 'UnknownConnectionType';

export class LockedError extends Error {}

export type CreateKeyRequest = {
  installationId: number;
  description: string;
  expires: string;
  permissions: string[];
};
